import { MediatorAction } from '@shared/types/action.interface';

export namespace HeroActions {
  export class Update implements MediatorAction {}
  export class UpdateName implements MediatorAction {}
  export class HeroChoose implements MediatorAction {}
  export class UpdateAvatar implements MediatorAction {
    constructor(public avatarUrl: string) {}
  }
}
